import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Paper, Typography } from '@mui/material'
import { useTheme } from '@mui/system'
import dayjs from 'dayjs'
import calendar from 'dayjs/plugin/calendar'
import { faExclamation } from '@fortawesome/free-solid-svg-icons'

import { styles } from './DataRequestedIndicator.styles'
import { FormattedMessage } from 'react-intl'
import intl from 'localization/components'

type DataRequestedProps = {
  eta: Date
}

export const DataRequestedIndicator = (props: DataRequestedProps) => {
  dayjs.extend(calendar)
  const { eta } = props
  const theme = useTheme()
  const classes = styles()

  return (
    <>
      <Paper
        style={{ ...classes.container, borderColor: theme.palette.success.main }}
        data-cy="data-requested-indicator"
      >
        <Box style={classes.textContainer}>
          <Typography variant="h4">
            <FormattedMessage id={intl.creditPolicy('req-additional-data-title')} />
          </Typography>
          <Typography variant="body1">
            <FormattedMessage id={intl.creditPolicy('req-additional-data-desc')} />
          </Typography>
          <Typography variant="body1" sx={classes.etaContainer}>
            <FormattedMessage id={intl.creditPolicy('eta')} />{' '}
            <Box>{dayjs().calendar(dayjs(eta))}</Box>
          </Typography>
        </Box>
        <Box
          sx={{
            ...classes.tickContainer,
            backgroundColor: theme.palette.success.main,
          }}
        >
          <FontAwesomeIcon icon={faExclamation as IconProp} style={classes.tick} />
        </Box>
      </Paper>
    </>
  )
}
